/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import styles from "./Greeting.module.css";
import { Auth } from "aws-amplify";
import { connect } from "react-redux";
import cx from "classnames";
import { constant } from "./../shared/constants/constants";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Launch from "@material-ui/icons/Launch";
import Tooltip from "./../Tooltip/Tooltip";

class Greeting extends Component {
  constructor(props) {
    super(props);
    this.geofencePropertyId = null;
  }
  // called when component is mounted
  componentWillMount() {
    // check if propertyId is present in query params or not
    // if propertyId is present need to show go back button
    let params = new URLSearchParams(window.location.search);
    let propertyId = params.get("propertyId");
    if (propertyId) this.geofencePropertyId = propertyId;
  }

  // sign out handler
  signOut = () => {
    Auth.signOut()
      .then(() => {
        window.open(process.env.REACT_APP_AUTH_URL, "_self");
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  // open url in browser
  openUrl = () => {
    window.open(window.location.href, "_blank");
  };

  render() {
    let redirectUrl = process.env.REACT_APP_BASE_URL + this.props.switchPath;

    return (
      <div>
        {this.props.isSignedIn && (
          <>
            <div className={cx(styles.BtnCont, styles.SwitchAlign)}>
              <a href={redirectUrl}>
                <button className={styles.Btn}>
                  {constant.SWITCH_TO + " " + this.props.switchPath}
                </button>
              </a>
            </div>
            <div className={styles.UrlIconCont} onClick={this.openUrl}>
              <Tooltip arrow title={constant.OPEN_IN_NEW_TAB}>
                <Launch color="inherit" fontSize="inherit" />
              </Tooltip>
            </div>
            {this.geofencePropertyId && (
              <div className={cx(styles.BtnContProperty, styles.SwitchAlign)}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${process.env.REACT_APP_MSA_URL}${constant.PROPERTY_URL}/${this.geofencePropertyId}`}>
                  <button className={styles.BtnProperty}>
                    <span className={styles.BackIcon}>
                      <ArrowBack fontSize="inherit" color="inherit" />
                    </span>
                    <span>{constant.GO_BACK}</span>
                  </button>
                </a>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSignedIn: state.auth.isSignedIn,
  };
};

export default connect(mapStateToProps, null)(Greeting);
